import {
  UserProfileAddPudDocument,
  UserProfileAddPudMutationVariables,
} from "@graphql/api";

interface Variables {
  creditCard?: be.CreditCard | be.TokenizedCreditCard;
  location: be.Pud;
}

export default async function userProfileAddPud(
  { creditCard, location }: Variables,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileAddPudMutationVariables = {
    location: {
      code: location.code ?? "",
      address: location.address,
      addressDetails: location.addressDetails,
      city: location.city,
      crossStreet: location.crossStreet,
      displayAddress: location.displayAddress,
      displayName: location.displayName,
      directions: location.directions,
      state: location.state,
      zip: location.zip,
      name: location.name,
      sector: location.sector,
      county: location.county,
      country: location.country,
      latLng: location.latLng?.lat ? { lat: location.latLng.lat, lng: location.latLng.lng } : null,
      googlePlaceId: location.googlePlaceId,
      type: location.type,
      pudName: location.pudName,
      locationType: location.locationType,
      email: location.email,
      telephone: location.telephone,
      telephone2: location.telephone2,
      faxNumber: location.faxNumber,
    },
  };
  if (creditCard) {
    // For regular CreditCard, use number field; for TokenizedCreditCard, use numberLast4
    const cardNumber = 'number' in creditCard ? creditCard.number : (creditCard as be.TokenizedCreditCard).numberLast4;
    // Only add credit card if it has valid data (both name and number)
    if (creditCard.name && cardNumber) {
      mutVars.location.creditCard = {
        number: cardNumber ?? '',
        expiration: creditCard.expiration ?? '',
        name: creditCard.name ?? '',
        address: creditCard.address,
        postalCode: creditCard.postalCode,
      };
    }
  }

  const result = await client.mutate({
    mutation: UserProfileAddPudDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileAddPud?.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileAddPud?.success ?? false;
}
